export default __webpack_public_path__ + "static/media/logovoip.6cb56d9b.png";